// insert player function
$.fn.insertPlayer = function () {
    let $video = $(this),
        $placeholder = $video.find('.fancy-video__placeholder'),
        $button = $video.find('.fancy-video__play'),
        vidWidth = $video.outerWidth(),
        vidHeight = $video.outerHeight(),
        vidID = $video.data('media-id'),
        fileURL = $video.data('video-file'),
        fileMobileURL = $video.data('video-file-mobile'),
        iframe;

    if (typeof vidID !== "undefined" && vidID !== '') {
        if ($video.attr('class').indexOf('youtube') >= 0) {
            iframe = '<iframe class="fancy-video__player" src="https://www.youtube.com/embed/'+vidID+'?autoplay=1&autohide=1&showinfo=0&controls=1&border=0&modestbranding=0&wmode=opaque&enablejsapi=1&version=3hl=nl_NL&rel=0&hd=1&iv_load_policy=3&mute=1" width="'+vidWidth+'" height="'+vidHeight+'" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
        }

        if ($video.attr('class').indexOf('vimeo') >= 0) {
            iframe = '<iframe class="fancy-video__player" src="https://player.vimeo.com/video/'+vidID+'" width="'+vidWidth+'" height="'+vidHeight+'" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
        }
    }

    if ($video.attr('class').indexOf('mp4') >= 0) {
        if (typeof fileURL !== 'undefined') {
            let vidURL = fileURL;

            if (viewport().width < 992) {
                if (typeof fileMobileURL !== 'undefined' && '' !== fileMobileURL) {
                    vidURL = fileMobileURL;
                }
            }

            iframe = '<video class="fancy-video__player" autoplay loop playsinline controls><source type="video/mp4" src="' + vidURL + '"></video>';
        }
    }

    if (iframe) {
        if (!$video.hasClass('fancy-video--playing')) {
            $video.addClass('fancy-video--playing');
        }

        $placeholder.hide();
        $button.hide();
        $video.append(iframe);
    }
};


$('.fancy-video__placeholder').on('click', function () {
    $(this).siblings('.fancy-video__play').trigger('click');
});


$('.fancy-video__play').on('click', function () {
    let $video = $(this).closest('.fancy-video');

    if ($video.length > 0) {
        $video.insertPlayer();
    }

    $('.btn--play-video[data-video-id="'+ $video.data('video-id') +'"]').prop('disabled', true).addClass('btn--disabled');
});

$('.btn--play-video').on('click', function () {
    let $video = $('.fancy-video[data-video-id="'+ $(this).data('video-id') +'"]'),
        $btn = $(this);

    if ($video.length > 0 && !$video.hasClass('fancy-video--playing')) {
        $video.insertPlayer();
    }

    $btn.prop('disabled', true).addClass('btn--disabled');
});